import { useCallback, useState } from 'react';

export type ThemeChoice = 'system' | 'light' | 'dark';
const STORAGE_KEY = 'vm-theme';

function read(): ThemeChoice {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'light' || v === 'dark') return v;
  } catch {
    // ei tallennustilaa
  }
  return 'system';
}

function apply(choice: ThemeChoice): void {
  const root = document.documentElement;
  if (choice === 'system') delete root.dataset.theme;
  else root.dataset.theme = choice;
  try {
    if (choice === 'system') localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, choice);
  } catch {
    // ei tallennustilaa
  }
}

/** Teema: laitteen mukaan, vaalea tai tumma. Valinta muistetaan tässä selaimessa. */
export function useTheme() {
  const [theme, setThemeState] = useState<ThemeChoice>(read);
  const setTheme = useCallback((choice: ThemeChoice) => {
    apply(choice);
    setThemeState(choice);
  }, []);
  return { theme, setTheme };
}
